import englishUSLayout from 'components/Keyboard/layouts/englishUS';
import { SPECIAL_KEYS } from 'components/Keyboard/utils/constants';

// Standard full-frame QWERTY layout (latin), reusing the US layout and adding the
// globe key at the bottom-left of the last row to switch back to the Japanese keyboard.
const withGlobe = (rows: string[]): string[] => [
  ...rows.slice(0, -1),
  `${SPECIAL_KEYS.NEXT_KEYBOARD} ${rows[rows.length - 1]}`,
];

const qwertyLayout = {
  default: withGlobe(englishUSLayout.layout.default),
  shift: withGlobe(englishUSLayout.layout.shift),
};

export default qwertyLayout;
